import { jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { Input } from "../input/input.es.js";
import { useNumberInput } from "../../hooks/use-number-input.es.js";
const propTypes = {
  format: PropTypes.func,
  label: PropTypes.string,
  max: PropTypes.number,
  message: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  min: PropTypes.number,
  numberType: PropTypes.oneOf(["decimal", "integer"]),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  step: PropTypes.number,
  textAlign: PropTypes.oneOf(["center", "left", "right"]),
  tone: PropTypes.oneOf(["critical", "neutral", "positive"]),
  value: PropTypes.number
};
const defaultProps = {
  format: void 0,
  label: void 0,
  max: void 0,
  message: void 0,
  min: void 0,
  numberType: "decimal",
  onBlur: void 0,
  onChange: void 0,
  onFocus: void 0,
  textAlign: void 0,
  tone: void 0,
  step: 1,
  value: void 0
};
const NumberInput = ({
  format,
  label,
  max,
  message,
  min,
  numberType,
  onBlur,
  onChange,
  onFocus,
  step,
  textAlign,
  tone,
  value,
  ...restProps
}) => {
  const { handleBlur, handleFocus, handleInput, handleKeyDown, inputValue } = useNumberInput({
    format,
    max,
    min,
    numberType,
    onBlur,
    onChange,
    onFocus,
    step,
    value
  });
  return /* @__PURE__ */ jsx(
    Input,
    {
      ...restProps,
      inputMode: "decimal",
      label,
      max,
      message,
      min,
      onBlur: handleBlur,
      onChange: handleInput,
      onFocus: handleFocus,
      onKeyDown: handleKeyDown,
      pattern: numberType === "integer" ? `-?[0-9]*` : `-?[.0-9]*`,
      step,
      textAlign,
      tone,
      type: "text",
      value: inputValue
    }
  );
};
NumberInput.propTypes = propTypes;
NumberInput.defaultProps = defaultProps;
export {
  NumberInput
};
